import * as Yup from 'yup';
import { Endpoints } from '@/api/ApiEndpoints';
const validationSchema = Yup.object().shape({
	halfTimeHomeTeamGoals: Yup.string().required().label('HalfTimeHomeTeamGoals'),
	halfTimeAwayTeamGoals: Yup.string().required().label('HalfTimeAwayTeamGoals'),
	homeTeamGoals: Yup.string().required().label('HomeTeamGoals'),
	awayTeamGoals: Yup.string().required().label('AwayTeamGoals'),
	fullTimeHomeTeamGoals: Yup.string().required().label('FullTime HomeTeamGoals'),
	fullTimeAwayTeamGoals: Yup.string().required().label('FullTime AwayTeamGoals'),
		
});
const Inputs= [
	{
		name: 'gameActions',
		label: 'Game Actions',
		type: 'apiButtons',
		customClass: 'col-12',
		hasDisplayConditions: true,
		displayCondition: (values) => !!values?.providerId,
		buttons: [
			{
				key: 'sync-game',
				label: 'Sync game',
				endpoint: (values) => Endpoints.SYNC_GAME+"/"+values?.providerId,
				method: 'GET',
				confirmMessage: 'Sync this game now?',
				successMessage: 'Game sync started',
			},
			{
				key: 're-validate-coupons',
				label: 'ReValidate Coupons',
				endpoint: (values) => Endpoints.VALIDATE_COUPON+"/"+values?.providerId,
				method: 'GET',
				confirmMessage: 'Validate coupons of this game? If there is a wrong validation this action will fix it (rollback points and coins).',
				successMessage: 'Validate coupons started',
			},
		],
	},
	{
		name: 'providerId',
		label: 'providerId',
		type: 'text',
		value: 'single',
		valueAttr: 'providerId',
		customClass: 'col-md-6 d-none'
	},
	
	{
		name: 'homeTeamName',
		label: 'HomeTeamName',
		type: 'hidden',
		value: 'single',
		valueAttr: 'homeTeamName',
		customClass: 'col-md-6'
	},
	{
		name: 'awayTeamName',
		label: 'awayTeamName',
		type: 'hidden',
		value: 'single',
		valueAttr: 'awayTeamName',
		customClass: 'col-md-6'
	},
	{
		name: 'halfTimeHomeTeamGoals',
		label: 'HalfTime HomeTeamG oals',
		type: 'text',
		value: 'single',
		valueAttr: 'halfTimeHomeTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'halfTimeAwayTeamGoals',
		label: 'HalfTime AwayTeam Goals',
		type: 'text',
		value: 'single',
		valueAttr: 'halfTimeAwayTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'homeTeamGoals',
		label: 'HomeTeam Goals',
		type: 'text',
		value: 'single',
		valueAttr: 'homeTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'awayTeamGoals',
		label: 'AwayTeam Goals',
		type: 'text',
		value: 'single',
		valueAttr: 'awayTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'fullTimeHomeTeamGoals',
		label: 'FullTime HomeTeam Goals',
		type: 'text',
		value: 'single',
		valueAttr: 'fullTimeHomeTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'fullTimeAwayTeamGoals',
		label: 'FullTime AwayTeam Goals',
		type: 'text',
		value: 'single',
		valueAttr: 'fullTimeAwayTeamGoals',
		customClass: 'col-md-6'
	},
	{
		name: 'markGameAsFinished',
		label: 'Mark Game As Finished',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'markGameAsFinished',
		customClass: 'col-md-12'
	}
];

export {Inputs, validationSchema};
